import { render, staticRenderFns } from "./CommerceAndTrade.vue?vue&type=template&id=037ce4d6&scoped=true&"
import script from "./CommerceAndTrade.vue?vue&type=script&lang=js&"
export * from "./CommerceAndTrade.vue?vue&type=script&lang=js&"
import style0 from "./CommerceAndTrade.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CommerceAndTrade.vue?vue&type=style&index=1&id=037ce4d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037ce4d6",
  null
  
)

export default component.exports